export default "__VITE_ASSET__CxvI8T6W__"